import * as React from 'react';

export const euFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_437)'>
            <mask
                id='mask0_1_437'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_437)'>
                <path
                    d='M25.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V17.3333C0 18.8061 1.19391 20 2.66667 20H25.3333C26.8061 20 28 18.8061 28 17.3333V2.66667C28 1.19391 26.8061 0 25.3333 0Z'
                    fill='#1A47B8'
                />
                <path
                    d='M14.0038 2.99994L14.2204 3.66971H14.9229L14.3537 4.08236L14.5706 4.75046L14.0038 4.33903L13.4332 4.75046L13.6518 4.08236L13.083 3.66971H13.7854L14.0038 2.99994Z'
                    fill='#FFCC00'
                />
                <path
                    d='M10.9446 3.83252L11.1658 4.50077L11.8683 4.49591L11.302 4.91249L11.5235 5.57907L10.9538 5.17157L10.3861 5.58694L10.6001 4.91735L10.0285 4.50864L10.7308 4.50378L10.9446 3.83252Z'
                    fill='#FFCC00'
                />
                <path
                    d='M7.79083 6.70548L8.49474 6.71117L8.71633 6.04459L8.92838 6.71485L9.63077 6.71982L9.06155 7.1279L9.27198 7.79914L8.70695 7.38096L8.13595 7.7905L8.3575 7.12401L7.79083 6.70548Z'
                    fill='#FFCC00'
                />
                <path
                    d='M6.97394 9.77523L7.67784 9.78227L7.9007 9.1161L8.11146 9.78677L8.81385 9.79307L8.24385 10.2001L8.453 10.8717L7.88877 10.4525L7.31699 10.8609L7.53981 10.1948L6.97394 9.77523Z'
                    fill='#FFCC00'
                />
                <path
                    d='M8.13306 13.9017L8.3548 13.2336L7.78857 12.8179L8.49157 12.8221L8.71216 12.1552L8.92556 12.8223L9.62898 12.8284L9.05739 13.2375L9.27163 13.9068L8.70548 13.4911L8.13306 13.9017Z'
                    fill='#FFCC00'
                />
                <path
                    d='M10.3833 16.1807L10.5993 15.5107L10.0296 15.0998L10.7326 15.0981L10.9475 14.4294L11.1666 15.0946L11.87 15.0947L11.3019 15.5087L11.5218 16.1761L10.9522 15.7652L10.3833 16.1807Z'
                    fill='#FFCC00'
                />
                <path
                    d='M14.0038 15.2494L14.2204 15.9192H14.9229L14.3537 16.3318L14.5706 16.9999L14.0038 16.5885L13.4332 16.9999L13.6518 16.3318L13.083 15.9192H13.7854L14.0038 15.2494Z'
                    fill='#FFCC00'
                />
                <path
                    d='M17.6235 16.1806L17.0551 15.7653L16.4863 16.1774L16.7051 15.5093L16.1375 15.0955L16.8379 15.0962L17.0586 14.4282L17.2735 15.0975L17.9762 15.098L17.4074 15.5101L17.6235 16.1806Z'
                    fill='#FFCC00'
                />
                <path
                    d='M19.8967 13.8948L19.3195 13.4918L18.7597 13.9161L18.964 13.2434L18.3877 12.8419L19.0879 12.8275L19.2942 12.155L19.5235 12.8195L20.226 12.8049L19.6663 13.2291L19.8967 13.8948Z'
                    fill='#FFCC00'
                />
                <path
                    d='M21.0264 9.77856L20.4561 10.1912L20.6727 10.8594L20.1047 10.4453L19.536 10.8576L19.7526 10.1916L19.1852 9.77569L19.8882 9.77757L20.1053 9.10927L20.3219 9.77737L21.0264 9.77856Z'
                    fill='#FFCC00'
                />
                <path
                    d='M20.2174 6.71352L19.647 7.12596L19.8634 7.79424L19.2955 7.37989L18.7267 7.79201L18.9435 7.12602L18.3763 6.70992L19.0792 6.71208L19.2966 6.04387L19.513 6.71206L20.2174 6.71352Z'
                    fill='#FFCC00'
                />
                <path
                    d='M17.0565 3.81907L17.2738 4.48864L17.9762 4.488L17.4075 4.90117L17.6249 5.56907L17.0577 5.15816L16.4875 5.57011L16.7055 4.90181L16.1364 4.48968L16.8387 4.48903L17.0565 3.81907Z'
                    fill='#FFCC00'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_437'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
